import { fetchJson } from './fetch-json'
import type { ApiResponse } from '../types'

export type ReportJobState = {
  current: { id: number; status: string; fetched_count: number; error_message: string; finished_at: string } | null
  lastSuccess: { finished_at: string; fetched_count: number } | null
}
async function call<T>(path: string, post = false) {
  const body = await fetchJson<ApiResponse<T>>(path, { method: post ? 'POST' : 'GET', credentials: 'include', cache: 'no-store', headers: { 'Content-Type': 'application/json' }, ...(post ? { body: '{}' } : {}) }, 10_000, '连接采集服务超时，请刷新查看最近结果')
  if (!body.success) throw new Error(body.error || '采集服务暂不可用')
  return body.data as T
}
export const readReportJob = (id?: number) => call<ReportJobState>(`/api/reports/sync/status${id === undefined ? '' : `?id=${id}`}`)

export async function collectReportsInBackground(progress?: (message: string) => void) {
  progress?.('正在提交后台采集任务…')
  const job = await call<{runId:number;reused:boolean}>('/api/reports/sync/start', true)
  progress?.(job.reused ? '已有后台任务，正在查询进度…' : '后台采集已启动，可继续浏览页面')
  const deadline = Date.now() + 75_000
  let failures = 0
  while (Date.now() < deadline) {
    await new Promise(resolve => setTimeout(resolve, 2000))
    let state: ReportJobState
    try { state = await readReportJob(job.runId); failures = 0 } catch (error) {
      if (++failures >= 3) throw error
      progress?.('暂时无法查询进度，正在重试；后台任务不受影响')
      continue
    }
    const run = state.current
    if (!run) throw new Error('未找到采集任务，请刷新查看最近结果')
    if (run.status === 'success') return { count: run.fetched_count, finishedAt: run.finished_at }
    if (run.status === 'failed') throw new Error(run.error_message || '源站暂不可用，旧内容已保留')
    progress?.(run.error_message || '后台正在采集…')
  }
  throw new Error('暂未取得最终结果，请刷新查看最近采集状态；请勿连续重复提交')
}
